import * as React from 'react';
import { FC } from 'react';

const Top: FC<{ title: string; type: string; reset: () => void }> = ({ title, type, reset }) => (
  <div className={`${type}-popup_top ${type}-top`}>
    <h2 className={`${type}-top_title`}>{title}</h2>
    <div className="td-top_close">
      <button type="button" aria-label="close popup" className="td-top_close-button" onClick={reset} />
    </div>
  </div>
);

export const Popup: FC<{
  type: string;
  title: string;
  visible: boolean;
  render: () => JSX.Element;
  reset: () => void;
}> = ({ type, title, visible, render, reset }) => {
  if (!visible) return null;

  return (
    <div className={`${type}-popup fixed-popup`} role="dialog">
      <div className={`${type}-popup_container fixed-popup_container`}>
        <Top title={title} type={type} reset={reset} />
        {render()}
      </div>
    </div>
  );
};
